import { render } from "./SectionView.vue?vue&type=template&id=1d458869"
import script from "./SectionView.vue?vue&type=script&lang=js"
export * from "./SectionView.vue?vue&type=script&lang=js"

import "./SectionView.vue?vue&type=style&index=0&id=1d458869&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/puchtrade-project/puchtrade/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__